module.exports = __webpack_public_path__ + "static/paymentSuccessYellow-75a544f63d1fd424dd48744ce8f924f8.png";